export const APP_NUMBER_COURSE_IDS = [1, 5];
export const COMM_ENG_COURSE_IDS = [2, 6];
export const COMM_WLS_COURSE_IDS = [3, 7];
export const DIGITAL_LIT_COURSE_IDS = [4, 8];
export const ESOL_COURSE_IDS = [9];
export const DIGITAL_LIT_SA_COURSE_ID = [10];
export const COMMUNICATION_COURSE_IDS = [2, 3, 6, 7];

export const USED_COURSE_IDS = [1, 2, 3, 4];
export const NOT_USED_COURSE_IDS = [5, 6, 7, 8, 9];

export const BETA_COURSE_IDS = [8];

export class CourseObjectId {
  static readonly DigLigSelfAssessment: string = "es_dlsa";
}